module.exports = __webpack_public_path__ + "img/green.fdae4eba.svg";